<template>
  <div>
    <div class="appui">
      <div class="appui-head">
        <div>
          <h1 class="appui-title">{{ partner.name || 'Patrocinador' }}</h1>
          <div class="appui-crumb">App <span class="sep">/</span> Patrocinadores <span class="sep">/</span> Conteúdo do estande</div>
        </div>
        <router-link to="/app/partners" class="appui-btn appui-btn--ghost" style="text-decoration:none"><i class="mdi mdi-arrow-left mr-1"></i> Voltar</router-link>
      </div>

      <div class="appui-tabs">
        <button :class="{ 'is-active': activeTab === 'videos' }" @click="activeTab = 'videos'"><i class="bx bx-video" style="margin-right:5px"></i>Vídeos</button>
        <button :class="{ 'is-active': activeTab === 'arquivos' }" @click="activeTab = 'arquivos'"><i class="bx bx-folder" style="margin-right:5px"></i>Arquivos</button>
        <button :class="{ 'is-active': activeTab === 'produtos' }" @click="activeTab = 'produtos'"><i class="bx bx-purchase-tag-alt" style="margin-right:5px"></i>Produtos</button>
        <button :class="{ 'is-active': activeTab === 'leads' }" @click="switchTab('leads')"><i class="bx bx-id-card" style="margin-right:5px"></i>Leads</button>
      </div>

      <!-- VÍDEOS -->
      <section v-if="activeTab === 'videos'" class="appui-card appui-card--flush">
        <div class="appui-tab-head">
          <span class="appui-sec-title">Vídeos do estande</span>
          <button class="appui-btn appui-btn--primary appui-btn--sm" @click="openVideo()">+ Inserir vídeo</button>
        </div>
        <div v-if="!videos.length" class="appui-inline-empty">Nenhum vídeo cadastrado.</div>
        <table v-else class="appui-table">
          <thead><tr><th>Descrição</th><th>URL</th><th style="width:80px">Ativo</th><th style="width:150px;text-align:right">Ações</th></tr></thead>
          <tbody>
            <tr v-for="v in videos" :key="v.id">
              <td style="font-weight:500;color:#495057">{{ v.description }}</td>
              <td style="color:#74788d;word-break:break-all;font-size:12px">{{ v.url_video }}</td>
              <td><button class="appui-switch" :class="{ 'is-on': v.status }" @click="toggleVideo(v)"><span class="knob"></span></button></td>
              <td style="text-align:right;white-space:nowrap">
                <button class="appui-tbtn" style="margin-right:6px" @click="openVideo(v)">Editar</button>
                <button class="appui-tbtn appui-tbtn--danger" @click="delVideo(v)">Excluir</button>
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      <!-- ARQUIVOS -->
      <section v-if="activeTab === 'arquivos'" class="appui-card appui-card--flush">
        <div class="appui-tab-head">
          <span class="appui-sec-title">Arquivos para download</span>
          <button class="appui-btn appui-btn--primary appui-btn--sm" @click="openArchive()">+ Inserir arquivo</button>
        </div>
        <div v-if="!archives.length" class="appui-inline-empty">Nenhum arquivo cadastrado.</div>
        <table v-else class="appui-table">
          <thead><tr><th>Descrição</th><th style="width:90px">Arquivo</th><th style="width:80px">Ativo</th><th style="width:150px;text-align:right">Ações</th></tr></thead>
          <tbody>
            <tr v-for="a in archives" :key="a.id">
              <td>
                <div style="display:flex;align-items:center;gap:10px">
                  <span class="appui-icon-chip"><i class="mdi mdi-file-document-outline"></i></span>
                  <span style="font-weight:500;color:#495057">{{ a.description }}</span>
                </div>
              </td>
              <td><a v-if="a.url_download" :href="a.url_download" target="_blank" rel="noopener" class="appui-tbtn appui-tbtn--primary" style="text-decoration:none"><i class="mdi mdi-download"></i> Abrir</a></td>
              <td><button class="appui-switch" :class="{ 'is-on': a.status }" @click="toggleArchive(a)"><span class="knob"></span></button></td>
              <td style="text-align:right;white-space:nowrap">
                <button class="appui-tbtn" style="margin-right:6px" @click="openArchive(a)">Editar</button>
                <button class="appui-tbtn appui-tbtn--danger" @click="delArchive(a)">Excluir</button>
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      <!-- PRODUTOS -->
      <section v-if="activeTab === 'produtos'" class="appui-card appui-card--flush">
        <div class="appui-card-toolbar">
          <div class="appui-card-toolbar-left"><span class="appui-sec-title">Produtos</span></div>
          <div class="appui-card-toolbar-right">
            <button class="appui-btn appui-btn--ghost" @click="prodCatModal = true"><i class="mdi mdi-tag-multiple-outline mr-1"></i> Categorias</button>
            <button class="appui-btn appui-btn--primary" @click="openProduct()">+ Inserir produto</button>
          </div>
        </div>
        <div v-if="!products.length" class="appui-inline-empty">Nenhum produto cadastrado.</div>
        <div v-else class="appui-grid-4" style="padding:16px">
          <div v-for="p in products" :key="p.id" class="appui-product-card">
            <div class="appui-product-photo">
              <img v-if="p.photo" :src="p.photo">
              <i v-else class="bx bx-purchase-tag-alt"></i>
            </div>
            <div style="padding:12px 14px">
              <div v-if="p.category" style="font-size:10.5px;font-weight:600;text-transform:uppercase;letter-spacing:.04em;color:#adb5bd">{{ p.category.name }}</div>
              <div style="font-weight:600;font-size:13px;color:#495057;margin:2px 0 10px">{{ p.name }}</div>
              <div style="display:flex;gap:8px">
                <button class="appui-tbtn" @click="openProduct(p)">Editar</button>
                <button class="appui-tbtn appui-tbtn--danger" @click="delProduct(p)">Excluir</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- LEADS -->
      <section v-if="activeTab === 'leads'" class="appui-card appui-card--flush">
        <div class="appui-card-toolbar">
          <div class="appui-card-toolbar-left"><span class="appui-sec-title">Leads capturados no estande</span></div>
          <div class="appui-card-toolbar-right">
            <button class="appui-btn appui-btn--ghost appui-btn--sm" @click="exportLeads()"><i class="mdi mdi-download mr-1"></i> Exportar</button>
            <button class="appui-btn appui-btn--ghost appui-btn--sm" @click="loadContacts()"><i class="mdi mdi-refresh mr-1"></i> Atualizar</button>
          </div>
        </div>
        <div v-if="!contacts.length" class="appui-inline-empty">Nenhum lead capturado ainda.</div>
        <table v-else class="appui-table">
          <thead><tr><th>Participante</th><th>Contato</th><th>Mensagem</th><th style="width:150px">Quando</th></tr></thead>
          <tbody>
            <tr v-for="c in contacts" :key="c.id">
              <td style="font-weight:500;color:#495057">{{ c.participant ? c.participant.name : '#' + c.participant_id }}</td>
              <td style="color:#74788d;font-size:12px">{{ c.participant ? c.participant.email : '' }}<br>{{ c.participant ? c.participant.phone : '' }}</td>
              <td style="color:#74788d">{{ c.message }}</td>
              <td style="color:#adb5bd;font-size:12px">{{ fmtDate(c.created_at) }}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>

    <!-- Modais -->
    <b-modal v-model="videoModal" :title="videoForm.id ? 'Editar vídeo' : 'Novo vídeo'" hide-footer>
      <form @submit.prevent="saveVideo()">
        <div class="form-group"><label>Descrição *</label><input type="text" class="form-control" v-model="videoForm.description" required></div>
        <div class="form-group"><label>URL do vídeo *</label><input type="url" class="form-control" v-model="videoForm.url_video" placeholder="https://..." required></div>
        <div class="text-right"><button type="button" class="btn btn-light mr-2" @click="videoModal = false">Cancelar</button><button type="submit" class="btn btn-primary" :disabled="saving">Salvar</button></div>
      </form>
    </b-modal>

    <b-modal v-model="archiveModal" :title="archiveForm.id ? 'Editar arquivo' : 'Novo arquivo'" hide-footer>
      <form @submit.prevent="saveArchive()">
        <div class="form-group"><label>Descrição *</label><input type="text" class="form-control" v-model="archiveForm.description" required></div>
        <div class="form-group"><label>URL de download *</label><input type="url" class="form-control" v-model="archiveForm.url_download" placeholder="https://..." required></div>
        <div class="text-right"><button type="button" class="btn btn-light mr-2" @click="archiveModal = false">Cancelar</button><button type="submit" class="btn btn-primary" :disabled="saving">Salvar</button></div>
      </form>
    </b-modal>

    <b-modal v-model="productModal" :title="productForm.id ? 'Editar produto' : 'Novo produto'" size="lg" hide-footer>
      <form @submit.prevent="saveProduct()">
        <div class="row">
          <div class="col-sm-4">
            <label class="appui-label">Foto</label>
            <input type="file" accept="image/*" ref="productPhoto" style="display:none" @change="onProductPhoto">
            <div class="appui-drop" :class="{ 'has-img': productPreview }" style="min-height:140px" @click="$refs.productPhoto.click()">
              <template v-if="productPreview">
                <img :src="productPreview" class="appui-drop-img">
                <div class="appui-drop-overlay"><span class="appui-drop-btn"><i class="mdi mdi-swap-horizontal"></i> Trocar</span></div>
              </template>
              <template v-else>
                <i class="mdi mdi-cloud-upload-outline appui-drop-icon"></i>
                <span class="appui-drop-hint">Quadrada · até 2 MB</span>
              </template>
            </div>
          </div>
          <div class="col-sm-8">
            <div class="form-group"><label>Nome *</label><input type="text" class="form-control" v-model="productForm.name" required></div>
            <div class="form-group">
              <label>Categoria</label>
              <select class="custom-select" v-model="productForm.partner_product_category_id">
                <option :value="null">—</option>
                <option v-for="pc in productCategories" :key="pc.id" :value="pc.id">{{ pc.name }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="form-group"><label>Descrição</label><textarea class="form-control" rows="3" v-model="productForm.description"></textarea></div>
        <div class="text-right"><button type="button" class="btn btn-light mr-2" @click="productModal = false">Cancelar</button><button type="submit" class="btn btn-primary" :disabled="saving">Salvar</button></div>
      </form>
    </b-modal>

    <!-- Modal categorias de produto -->
    <b-modal v-model="prodCatModal" title="Categorias de produto" hide-footer>
      <form class="d-flex mb-3" style="gap:8px" @submit.prevent="addProdCat()">
        <input type="text" class="form-control" v-model.trim="newProdCat" placeholder="Nova categoria" required>
        <button type="submit" class="btn btn-primary" style="flex:none">Adicionar</button>
      </form>
      <table class="appui-table">
        <tbody>
          <tr v-for="pc in productCategories" :key="pc.id">
            <td>{{ pc.name }}</td>
            <td style="width:50px;text-align:right">
              <button class="appui-icon-btn appui-icon-btn--danger" @click="delProdCat(pc)"><i class="mdi mdi-trash-can-outline"></i></button>
            </td>
          </tr>
          <tr v-if="!productCategories.length"><td colspan="2" class="appui-empty">Nenhuma categoria.</td></tr>
        </tbody>
      </table>
      <div class="text-right" style="margin-top:12px"><button class="btn btn-light" @click="prodCatModal = false">Fechar</button></div>
    </b-modal>
  </div>
</template>

<script>
import { errorMessage, successMessage } from '@/components/alertsMessages'
import services from './services'
import './app-ui.css'

export default {
  components: {},
  name: 'app-partner-edit',
  data () {
    return {
      id: this.$route.params.id,
      partner: {},
      activeTab: 'videos',
      videos: [],
      archives: [],
      products: [],
      productCategories: [],
      contacts: [],
      saving: false,
      newProdCat: '',
      videoModal: false,
      videoForm: {},
      archiveModal: false,
      archiveForm: {},
      productModal: false,
      productForm: {},
      productPhoto: null,
      productPreview: null,
      prodCatModal: false
    }
  },
  mounted () {
    services.showPartner(this.id).then(r => { this.partner = r.data.data }).catch(() => {})
    this.loadVideos()
    this.loadArchives()
    this.loadProducts()
    this.loadProductCategories()
  },
  methods: {
    switchTab (tab) { this.activeTab = tab; if (tab === 'leads') this.loadContacts() },
    fmtDate (d) {
      if (!d) return ''
      const dt = new Date(String(d).replace(' ', 'T'))
      if (isNaN(dt)) return d
      return dt.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
    },
    // Vídeos
    loadVideos () { services.listPartnerVideos(this.id).then(r => { this.videos = r.data.data }) },
    openVideo (v) { this.videoForm = v ? { ...v } : { description: '', url_video: '' }; this.videoModal = true },
    async saveVideo () {
      this.saving = true
      try {
        if (this.videoForm.id) await services.updatePartnerVideo(this.id, this.videoForm.id, this.videoForm)
        else await services.createPartnerVideo(this.id, this.videoForm)
        this.videoModal = false
        successMessage('Vídeo salvo.', 2000)
        this.loadVideos()
      } catch (e) { errorMessage('Falha ao salvar vídeo.', 3000) } finally { this.saving = false }
    },
    async toggleVideo (v) {
      const next = v.status ? 0 : 1
      try {
        await services.updatePartnerVideo(this.id, v.id, { description: v.description, url_video: v.url_video, status: next })
        v.status = next
      } catch (e) { errorMessage('Falha ao alterar status.', 3000) }
    },
    async delVideo (v) { if (!(await this.confirm())) return; await services.deletePartnerVideo(this.id, v.id); this.loadVideos() },
    // Arquivos
    loadArchives () { services.listPartnerArchives(this.id).then(r => { this.archives = r.data.data }) },
    openArchive (a) { this.archiveForm = a ? { ...a } : { description: '', url_download: '' }; this.archiveModal = true },
    async saveArchive () {
      this.saving = true
      try {
        const fd = new FormData()
        fd.append('description', this.archiveForm.description)
        fd.append('url_download', this.archiveForm.url_download || '')
        if (this.archiveForm.id) await services.updatePartnerArchive(this.id, this.archiveForm.id, fd)
        else await services.createPartnerArchive(this.id, fd)
        this.archiveModal = false
        successMessage('Arquivo salvo.', 2000)
        this.loadArchives()
      } catch (e) { errorMessage(e?.response?.data?.message || 'Falha ao salvar arquivo.', 3000) } finally { this.saving = false }
    },
    async toggleArchive (a) {
      const next = a.status ? 0 : 1
      try {
        const fd = new FormData()
        fd.append('description', a.description)
        fd.append('status', next)
        await services.updatePartnerArchive(this.id, a.id, fd)
        a.status = next
      } catch (e) { errorMessage('Falha ao alterar status.', 3000) }
    },
    async delArchive (a) { if (!(await this.confirm())) return; await services.deletePartnerArchive(this.id, a.id); this.loadArchives() },
    // Produtos
    loadProducts () { services.listPartnerProducts(this.id).then(r => { this.products = r.data.data }) },
    loadProductCategories () { services.listPartnerProductCategories(this.id).then(r => { this.productCategories = r.data.data }) },
    async addProdCat () {
      if (!this.newProdCat) return
      try {
        await services.createPartnerProductCategory(this.id, { name: this.newProdCat })
        this.newProdCat = ''
        this.loadProductCategories()
      } catch (e) { errorMessage('Falha ao criar categoria.', 3000) }
    },
    async delProdCat (pc) { if (!(await this.confirm())) return; await services.deletePartnerProductCategory(this.id, pc.id); this.loadProductCategories(); this.loadProducts() },
    openProduct (p) {
      this.productForm = p ? { ...p } : { name: '', description: '', partner_product_category_id: null }
      this.productPhoto = null
      this.productPreview = p ? p.photo : null
      this.productModal = true
    },
    onProductPhoto (e) {
      const f = e.target.files[0]
      e.target.value = ''
      if (!f) return
      if (!f.type.startsWith('image/')) { errorMessage('Envie um arquivo de imagem.', 2500); return }
      if (f.size > 2 * 1024 * 1024) { errorMessage('A imagem deve ter no máximo 2 MB.', 2500); return }
      this.productPhoto = f
      this.productPreview = URL.createObjectURL(f)
    },
    async saveProduct () {
      this.saving = true
      try {
        const fd = new FormData()
        fd.append('name', this.productForm.name)
        if (this.productForm.description) fd.append('description', this.productForm.description)
        if (this.productForm.partner_product_category_id) fd.append('partner_product_category_id', this.productForm.partner_product_category_id)
        if (this.productPhoto) fd.append('photo', this.productPhoto)
        if (this.productForm.id) await services.updatePartnerProduct(this.id, this.productForm.id, fd)
        else await services.createPartnerProduct(this.id, fd)
        this.productModal = false
        successMessage('Produto salvo.', 2000)
        this.loadProducts()
      } catch (e) { errorMessage('Falha ao salvar produto.', 3000) } finally { this.saving = false }
    },
    async delProduct (p) { if (!(await this.confirm())) return; await services.deletePartnerProduct(this.id, p.id); this.loadProducts() },
    // Leads
    loadContacts () { services.listPartnerContacts(this.id, { limit: 100 }).then(r => { this.contacts = r.data.data }).catch(() => {}) },
    async exportLeads () {
      const loader = this.$loading.show()
      try {
        const res = await services.exportPartnerContacts(this.id)
        const url = URL.createObjectURL(new Blob([res.data]))
        const a = document.createElement('a')
        a.href = url
        a.download = 'leads-' + (this.partner.name || 'patrocinador') + '.xlsx'
        a.click()
        URL.revokeObjectURL(url)
      } catch (e) { errorMessage('Falha ao exportar.', 3000) } finally { loader.hide() }
    },
    confirm () { return this.$bvModal.msgBoxConfirm('Remover este item?', { okTitle: 'Remover', cancelTitle: 'Cancelar', okVariant: 'danger' }) }
  }
}
</script>
